module.exports = __webpack_public_path__ + "img/digital-signage-installation.c4d6b781.webp";